module.exports = __webpack_public_path__ + "img/c4a0fb4.png";